import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { FormService } from '../../../../../../../form/form.service';

@Component({
    selector: 'app-debt-input',
    template: `
        <h6 *ngIf="!showForm" (click)="toggleShowForm()" class="no-margin text-small link theme-text">
            {{ 'loan.calc_outstanding_debt_button' | translate }}
        </h6>
        <form *ngIf="showForm && form" class="flow__form" [formGroup]="form" (ngSubmit)="onSubmit()">
            <section class="debt__input-wrapper">
                <app-input
                    controlName="debt"
                    [inputMode]="'decimal'"
                    [label]="
                        'loan.outstanding_debt_input_placeholder' | translate
                    "
                    [parentForm]="form"
                ></app-input>

                <app-button buttonType="submit" buttonClass="button--primary button--has-spacing">
                    {{ 'generic.save' | translate }}
                </app-button>
            </section>
        </form>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebtInputComponent {
    @Output() handleChange = new EventEmitter();
    showForm = false;
    form?: UntypedFormGroup;
    constructor(private fb: UntypedFormBuilder) {
        this.form = this.fb.group(
            {
                debt: ['', { validators: [Validators.pattern('^[0-9]*$'), Validators.maxLength(6)] }], // whole numbers only
            },
            {
                updateOn: 'change',
            }
        );
    }
    onSubmit() {
        if (this.form?.invalid || this.form?.disabled) {
            FormService.markControlsAsTouched(this.form);
            return;
        }
        const { debt }: { [key: string]: string } = this.form?.value;
        this.handleChange.emit(debt);
        this.toggleShowForm();
    }

    toggleShowForm() {
        this.showForm = !this.showForm;
    }
}
